import styles from './Components.module.css'

const fmt = (n) => `$${Number(n || 0).toLocaleString('es-CO', { maximumFractionDigits: 0 })}`
const pct = (n) => `${Number(n || 0).toFixed(1)}%`

const COMPONENTES = [
    ['venta', 'Comisiones por venta'],
    ['recaudo', 'Comisiones por recaudo'],
    ['nuevos_clientes', 'Clientes nuevos'],
    ['nuevos_comodatos', 'Nuevos comodatos'],
]

function GaugeBar({ value }) {
    const w = Math.min((value / 100) * 100, 100)
    const getColor = () => {
        if (value >= 100) return '#48c78e'
        if (value >= 70) return '#a78bfa'
        if (value >= 50) return '#ffb800'
        return '#f87171'
    }

    return (
        <div className={styles.gaugeWrap}>
            <div className={styles.gaugeTrack}>
                <div className={styles.gaugeFill} style={{ width: `${w}%`, background: getColor() }} />
                {[50, 70, 100].map(mark => (
                    <div key={mark} className={styles.gaugeMark} style={{ left: `${mark}%` }} title={`${mark}%`} />
                ))}
            </div>
            <span className={styles.gaugeLabel} style={{ color: getColor() }}>{pct(value)}</span>
        </div>
    )
}

function DetalleFila({ regla }) {
    return (
        <div className={styles.detalleRow}>
            <div className={styles.detalleLeft}>
                <span className={styles.detalleNombre}>{regla.nombre}</span>
                <span className={styles.detalleTipo}>{regla.tipo}</span>
                {regla.detalle && <span className={styles.detalleDesc}>{regla.detalle}</span>}
            </div>
            <span className={`${styles.detalleValor} ${regla.valor_cop > 0 ? styles.valorPositivo : ''}`}>
                {fmt(regla.valor_cop)}
            </span>
        </div>
    )
}

function ComponentesResumen({ componentes = {} }) {
    return (
        <div className={styles.componentesGrid}>
            {COMPONENTES.map(([key, label]) => {
                const comp = componentes[key] || {}
                const detalles = comp.detalle || []

                return (
                    <div key={key} className={styles.componenteCard}>
                        <span className={styles.componenteLabel}>{label}</span>
                        <strong className={Number(comp.valor_cop || 0) > 0 ? styles.valorPositivo : ''}>
                            {fmt(comp.valor_cop)}
                        </strong>
                        {detalles.length > 0 && (
                            <small>{detalles.map(d => d.detalle).join(' · ')}</small>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

function GestorResultadoCard({ plan, datos }) {
    const calc = datos?.comision_calculada || {}
    const tieneCalculo = calc.total_cop != null
    const estado = datos?.estado || 'sin_datos'
    const estadoColors = {
        aprobado: { color: '#48c78e', bg: 'rgba(72,199,142,0.12)' },
        enviado: { color: '#ffb800', bg: 'rgba(255,184,0,0.12)' },
        rechazado: { color: '#f87171', bg: 'rgba(248,113,113,0.12)' },
        borrador: { color: '#63b3ed', bg: 'rgba(99,179,237,0.12)' },
        sin_datos: { color: '#4b5563', bg: 'rgba(75,85,99,0.08)' },
    }
    const cfg = estadoColors[estado] || estadoColors.sin_datos

    return (
        <div className={styles.resultadoCard} style={{ borderColor: cfg.color + '40' }}>
            <div className={styles.resultadoCardHeader}>
                <div className={styles.planAvatar} style={{ background: cfg.bg, color: cfg.color }}>
                    {(plan.gestor_nombre || plan.gestor_email).charAt(0).toUpperCase()}
                </div>
                <div className={styles.resultadoCardInfo}>
                    <h3>{plan.gestor_nombre || plan.gestor_email}</h3>
                    <p>{plan.gestor_email}</p>
                    {plan.region && <span className={styles.regionBadge}>📍 {plan.region}</span>}
                </div>
                <div className={styles.resultadoEstado}>
                    <span className={styles.estadoBadge} style={{ color: cfg.color, background: cfg.bg }}>
                        {estado.charAt(0).toUpperCase() + estado.slice(1).replace('_', ' ')}
                    </span>
                    {tieneCalculo && (
                        <div className={styles.totalComision}>
                            <span>{estado === 'aprobado' ? 'Comisión total' : 'Comisión estimada'}</span>
                            <strong style={{ color: '#48c78e' }}>{fmt(calc.total_cop)}</strong>
                        </div>
                    )}
                </div>
            </div>

            {datos ? (
                <>
                    <div className={styles.metricsGrid}>
                        <div className={styles.metricItem}>
                            <span className={styles.metricLabel}>Ventas</span>
                            <strong className={styles.metricVal}>{fmt(datos.ventas_periodo)}</strong>
                            {calc.pct_venta_meta != null && <GaugeBar value={calc.pct_venta_meta} />}
                        </div>
                        <div className={styles.metricItem}>
                            <span className={styles.metricLabel}>Recaudo</span>
                            <strong className={styles.metricVal}>{fmt(datos.recaudo_periodo)}</strong>
                            {calc.pct_recaudo_meta != null && <GaugeBar value={calc.pct_recaudo_meta} />}
                        </div>
                        <div className={styles.metricItem}>
                            <span className={styles.metricLabel}>Nuevos clientes</span>
                            <strong className={styles.metricVal}>{datos.nuevos_clientes}</strong>
                        </div>
                        <div className={styles.metricItem}>
                            <span className={styles.metricLabel}>Comodatos</span>
                            <strong className={styles.metricVal}>{datos.nuevos_comodatos}</strong>
                        </div>
                    </div>

                    {tieneCalculo && <ComponentesResumen componentes={calc.componentes} />}

                    {tieneCalculo && calc.detalle_reglas?.length > 0 && (
                        <div className={styles.detalleSection}>
                            <h4 className={styles.detalleTitle}>Desglose de reglas</h4>
                            {calc.detalle_reglas.map((r, i) => (
                                <DetalleFila key={i} regla={r} />
                            ))}
                            {calc.bonos_aplicados?.length > 0 && (
                                <>
                                    <div className={styles.detalleSeparator}>Bonificaciones</div>
                                    {calc.bonos_aplicados.map((b, i) => (
                                        <div key={i} className={styles.detalleRow}>
                                            <span className={styles.detalleNombre}>🏅 {b.nombre}</span>
                                            <span className={`${styles.detalleValor} ${styles.valorBono}`}>{fmt(b.valor_cop)}</span>
                                        </div>
                                    ))}
                                </>
                            )}
                            <div className={styles.detalleTotalRow}>
                                <span>Total comisión</span>
                                <strong>{fmt(calc.total_cop)}</strong>
                            </div>
                        </div>
                    )}

                    {datos.notas && <p className={styles.notasText}>💬 {datos.notas}</p>}
                </>
            ) : (
                <div className={styles.sinDatosMsg}>Sin datos de rendimiento ingresados</div>
            )}
        </div>
    )
}

function ResultadoPanel({ planes, datos, periodo }) {
    const aprobados = datos.filter(d => d.estado === 'aprobado')
    const datosConCalculo = datos.filter(d => d.comision_calculada?.total_cop != null)
    const totalComisiones = datosConCalculo.reduce((acc, d) => acc + (d.comision_calculada?.total_cop || 0), 0)
    const totalVentas = datos.reduce((acc, d) => acc + (d.ventas_periodo || 0), 0)
    const totalRecaudo = datos.reduce((acc, d) => acc + (d.recaudo_periodo || 0), 0)

    const planesConDatos = planes.map(plan => ({
        plan,
        datos: datos.find(d => d.gestor_email === plan.gestor_email) || null,
    }))

    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <div>
                    <h2 className={styles.sectionTitle}>💰 Resumen de Comisiones — {periodo}</h2>
                    <p className={styles.sectionSub}>Vista consolidada de todos los gestores del período</p>
                </div>
            </div>

            <div className={styles.totalesRow}>
                <div className={styles.totalCard}>
                    <span className={styles.totalIcon}>💰</span>
                    <div>
                        <p className={styles.totalLabel}>Total comisiones estimadas</p>
                        <strong className={styles.totalVal} style={{ color: '#48c78e' }}>{fmt(totalComisiones)}</strong>
                    </div>
                </div>
                <div className={styles.totalCard}>
                    <span className={styles.totalIcon}>📈</span>
                    <div>
                        <p className={styles.totalLabel}>Total ventas registradas</p>
                        <strong className={styles.totalVal}>{fmt(totalVentas)}</strong>
                    </div>
                </div>
                <div className={styles.totalCard}>
                    <span className={styles.totalIcon}>🏦</span>
                    <div>
                        <p className={styles.totalLabel}>Total recaudo registrado</p>
                        <strong className={styles.totalVal}>{fmt(totalRecaudo)}</strong>
                    </div>
                </div>
                <div className={styles.totalCard}>
                    <span className={styles.totalIcon}>👥</span>
                    <div>
                        <p className={styles.totalLabel}>Gestores aprobados</p>
                        <strong className={styles.totalVal}>{aprobados.length} / {planes.length}</strong>
                    </div>
                </div>
            </div>

            {planesConDatos.length === 0 ? (
                <div className={styles.empty}>
                    <span>💰</span>
                    <p>No hay planes configurados para {periodo}</p>
                </div>
            ) : (
                <div className={styles.resultadosGrid}>
                    {planesConDatos.map(({ plan, datos: d }) => (
                        <GestorResultadoCard key={plan.gestor_email} plan={plan} datos={d} />
                    ))}
                </div>
            )}
        </div>
    )
}

export default ResultadoPanel
